import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  subQuote: false,
  subJobsheet: false,
  subOrders: false,
  subStore: false,
  subDocs: false,
  subDiecut: false,
  subProd: false,
  subUser: false,
  subReport: false,
};

export const pageSlice = createSlice({
  name: "pages",
  initialState,
  reducers: {
    toggleQuote: (state) => {
      state.subQuote = !state.subQuote;
      state.subJobsheet = false;
      state.subOrders = false;
      state.subStore = false;
      state.subDocs = false;
      state.subDiecut = false;
      state.subProd = false;
      state.subUser = false; state.subReport = false;
    },
    toggleJobsheet: (state) => {
      state.subJobsheet = !state.subJobsheet;
      state.subQuote = false;
      state.subOrders = false;
      state.subStore = false;
      state.subDocs = false;
      state.subDiecut = false;
      state.subProd = false;
      state.subUser = false; state.subReport = false;
    },
    toggleOrders: (state) => {
      state.subOrders = !state.subOrders;
      state.subJobsheet = false;
      state.subQuote = false;
      state.subStore = false;
      state.subDocs = false;
      state.subDiecut = false;
      state.subProd = false;
      state.subUser = false; state.subReport = false;
    },
    toggleStore: (state) => {
      state.subStore = !state.subStore;
      state.subJobsheet = false;
      state.subOrders = false;
      state.subQuote = false;
      state.subDocs = false;
      state.subDiecut = false;
      state.subProd = false;
      state.subUser = false; state.subReport = false;
    },
    toggleDocs: (state) => {
      state.subDocs = !state.subDocs;
      state.subJobsheet = false;
      state.subOrders = false;
      state.subStore = false;
      state.subQuote = false;
      state.subDiecut = false;
      state.subProd = false;
      state.subUser = false; state.subReport = false;
    },
    toggleDiecut: (state) => {
      state.subDiecut = !state.subDiecut;
      state.subJobsheet = false;
      state.subOrders = false;
      state.subStore = false;
      state.subQuote = false;
      state.subDocs = false;
      state.subProd = false;
      state.subUser = false; state.subReport = false;
    },
    toggleProd: (state) => {
      state.subProd = !state.subProd;
      state.subJobsheet = false;
      state.subOrders = false;
      state.subStore = false;
      state.subQuote = false;
      state.subDocs = false;
      state.subDiecut = false;
      state.subUser = false; state.subReport = false;
    },
    toggleUser: (state) => {
      state.subUser = !state.subUser;
      state.subProd = false;
      state.subJobsheet = false;
      state.subOrders = false;
      state.subStore = false;
      state.subQuote = false;
      state.subDocs = false;
      state.subDiecut = false;
      state.subReport = false;
    },
    toggleReport: (state) => {
      state.subReport = !state.subReport;
      state.subUser = false;
      state.subProd = false;
      state.subJobsheet = false;
      state.subOrders = false;
      state.subStore = false;
      state.subQuote = false;
      state.subDocs = false;
      state.subDiecut = false;
    },
  },
});

export const {
  toggleQuote,
  toggleJobsheet,
  toggleOrders,
  toggleStore,
  toggleDocs,
  toggleDiecut,
  toggleProd,
  toggleUser,
  toggleReport,
} = pageSlice.actions;

export default pageSlice.reducer;
